import React, { memo } from "react";
import LinkPreview from "./LinkPreview";
import Code from "./Code";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";
import { safeUrl } from "utils/safeHtml";

type MarkdownViewerProps = {
  uuid: string;
  handleApplyAi?: (model: string) => Promise<void>;
  message: string;
};

const MarkdownViewer: React.FC<MarkdownViewerProps> = ({
  uuid,
  handleApplyAi,
  message,
}) => {
  return (
    <ReactMarkdown
      key={"markdown" + uuid}
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ href, children, ...rest }) => {
          const safeHref = safeUrl(href);
          if (!safeHref) return <span>{children}</span>;
          return (
            <LinkPreview
              key={`link-preview-${uuid}`}
              {...rest}
              href={safeHref}
            >
              {children}
            </LinkPreview>
          );
        },
        code: (props) => (
          <Code {...props} uuid={uuid} onApply={handleApplyAi} />
        ),
      }}
    >
      {message}
    </ReactMarkdown>
  );
};

export default memo(MarkdownViewer);
